<template>
  <div>
    <header
      :class="expanded ? 'menu-expanded' : null"
      class="header__container"
    >
      <div class="header">
        <router-link :to="{ name: 'home' }">
          <svg
            class="logo"
            viewBox="0 0 323.588 207.442"
          >
            <path
              :class="expanded ? 'menu-expanded' : null"
              class="blade"
              d="M202.164 0L0 207.442h121.424L323.588 0H202.164z"
            />
            <!-- eslint-disable max-len -->
            <path
              class="text"
              d="M51.646 145.312a5.144 5.144 0 0 1-3.865 4.766q-3.217.735-6.43 1.515a2.937 2.937 0 0 1-3.851-2.948V62.351q-8.78 2.2-17.5 4.738v90.192c0 9.832 7.8 15.486 17.5 13.055q7.056-1.77 14.146-3.332c9.751-2.152 17.7-11.519 17.7-21.352V55.46q-8.876 1.615-17.7 3.559zm64.786-48.303q-7.2-18.105-14.383-36V50.63Q93.1 51.647 84.2 52.99v107.985q8.91-1.342 17.854-2.36v-47.741q7.183 17.893 14.383 36v10.32q8.962-.753 17.942-1.18V48.027q-8.979.427-17.942 1.181zm161.751 51.636a2.937 2.937 0 0 1-3.851 2.948q-5.138-1.246-10.294-2.382v-72.4q5.157 1.134 10.294 2.381a5.264 5.264 0 0 1 3.851 4.85zm0-86.294q-7.054-1.77-14.145-3.332-8.827-1.944-17.7-3.559v107.985q8.875 1.617 17.7 3.559 7.09 1.56 14.145 3.333c9.7 2.43 17.5-3.223 17.5-13.056v-72.4c0-9.822-7.8-20.1-17.5-22.531m-77.23-12.996q-8.077-.706-16.173-1.15V66q8.093.441 16.173 1.149v90.191q8.963.783 17.9 1.9V69.044q8.055 1 16.083 2.27V53.522q-8.026-1.269-16.083-2.271-8.934-1.111-17.9-1.9M169.041 47.6q-8.983-.2-17.97-.08V155.5q8.984-.125 17.97.08 9.6.218 19.19.809V138.6q-9.586-.591-19.19-.808z"
            />
            <!-- eslint-enable max-len -->
          </svg>
        </router-link>
        <nav
          id="menu__large"
          class="menu__large"
        >
          <ul class="links">
            <li
              v-for="({ text, to }) in links"
              :key="text"
              class="link"
            >
              <router-link
                :to="to"
                class="text"
                v-text="text"
              />
            </li>
          </ul>
          <div
            class="menu__button--dummy"
            aria-hidden="true"
          >
            <span class="crust__wrapper">
              <span class="crust__line crust__line-left"/>
              <span class="crust__line crust__line-right"/>
            </span>
          </div>
        </nav>
        <button
          :aria-expanded="expanded.toString()"
          controls="menu__small"
          class="menu__button"
          @click="toggleMenu()"
        >
          <span class="crust__wrapper">
            <span class="crust__line crust__line-left"/>
            <span class="crust__line crust__line-right"/>
          </span>
        </button>
      </div>
    </header>
    <nav
      id="menu__small"
      :class="expanded ? 'menu-expanded' : null"
      class="menu__small"
    >
      <ul class="menu__small--list">
        <li
          v-for="({ text, to }) in links"
          :key="text"
          class="menu__small--list-item"
        >
          <router-link
            :to="to"
            class="menu__small--link"
            v-text="text"
          />
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
  import Menu from '@/api/menus';
  import { cleanMenuItem } from '@/util/cleaners';

  export default {
    data() {
      return {
        links: undefined,
        expanded: false,
      };
    },
    watch: {
      $route() {
        this.expanded = false;
      },
    },
    async created() {
      this.links = (await Menu.find('header')).map(cleanMenuItem);
    },
    methods: {
      toggleMenu() {
        this.expanded = !this.expanded;
      },
    },
  };
</script>

<style
  scoped
  lang="scss"
>
  .blade {
    fill: color(red);
    transition-property: fill;
    transition-timing-function: timing-function(accelerate);
    transition-duration: duration(fast);

    &.menu-expanded {
      fill: color(bronze);
      transition-timing-function: timing-function(decelerate);
    }
  }

  .mission-expanded {

    .header__container {
      z-index: 10;

      @include breakpoint(laptop) {
        z-index: 14;
      }
    }
  }

  .header__container {
    @include container;

    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    width: 100%;
    z-index: 14;

    &.menu-expanded {
      position: fixed;
    }
  }

  .header {
    @include column;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: spacing(delta);
    padding-bottom: spacing(delta);
  }

  .link {
    font-family: font-family(sans-serif);
    font-weight: font-weight(bold);
    font-size: 1.6rem;
    color: color(white);
    display: block;
    padding: spacing(delta) * 0.5;
    text-transform: uppercase;
    letter-spacing: 1px;
    transition-property: color;
    transition-timing-function: timing-function(accelerate);
    transition-duration: duration(fast);

    &:focus,
    &:hover {
      color: color(red);
      transition-timing-function: timing-function(decelerate);
    }
  }

  .links {
    display: flex;
  }

  .logo {
    height: 35px;

    @include breakpoint(tablet) {
      height: 64px;
    }
  }

  .text {
    fill: color(white);
  }

.crust__wrapper {
  display: inline-block;
  position: relative;
  transform: rotate(45deg);
  width: 8px;
  display: flex;
  justify-content: space-between;
}

.crust__line {
  display: inline-block;
  width: 2px;
  height: 35px;
  background-color: color(red);
  transition: ease 50ms transform;
}

.crust__line-left {
  transform: translateY(-10%);
}

.crust__line-right {
  transform: translateY(10%);
}

.menu__button {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 45px;
  outline: 0;
  transition-property: background-color transform;
  transition-timing-function: timing-function(accelerate);
  transition-duration: duration(fast);

  @include breakpoint(laptop) {
    display: none;
  }
}

.menu__button--dummy {
  position: relative;
  display: none;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  margin-left: spacing(base-delta);

  @include breakpoint(laptop) {
    display: flex;
  }

  .crust__line-left {
    transform: translateY(-35%);
  }

  .crust__line-right {
    transform: translateY(35%);
  }
}

.menu__button[aria-expanded="true"] {

  .crust__line {
    background-color: color(white);
    transition-timing-function: timing-function(decelerate);
  }

  .crust__line-left {
    transform: translateY(-35%);
    transition-timing-function: timing-function(decelerate);
  }

  .crust__line-right {
    transform: translateY(35%);
    transition-timing-function: timing-function(decelerate);
  }
}

.menu__button:hover {
  .crust__line {
    background-color: color(bronze);
    transition-timing-function: timing-function(decelerate);
  }
}

.menu__button:focus {
  .crust__line {
    background-color: color(white);
    transition-timing-function: timing-function(decelerate);
  }
}

.menu__large {
  display: none;

  @include breakpoint(laptop) {
    display: flex;
  }
}

.menu__small {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 13;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: color(red);
  pointer-events: none;
  user-select: none;
  opacity: 0;
  transition-property: opacity;
  transition-timing-function: timing-function(accelerate);
  transition-duration: duration(fast);

  @include breakpoint(laptop) {
    display: none;
  }

  &.menu-expanded {
    opacity: 1;
    pointer-events: all;
    user-select: all;
    transition-timing-function: timing-function(decelerate);
  }
}

.menu__small--list-item {
  position: relative;
  text-align: center;

  &::after {
    position: absolute;
    bottom: 0;
    left: 50%;
    display: block;
    content: "";
    width: 10px;
    height: 2px;
    background-color: color(bronze);
    transform: translateX(-50%);
  }

  &:last-child {
    &::after {
      content: none;
    }
  }
}

.menu__small--link {
  position: relative;
  display: inline-block;
  padding-top: spacing(base-gamma);
  padding-bottom: spacing(base-gamma);
  font-family: font-family(serif);
  font-size: 2.6rem;
  color: color(white);
  text-align: center;
}
</style>
